import { Box, Button, Flex, FormControl, FormLabel, Spacer, Stack } from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../../stores/pipeline-store';
import { DrawerInput, VarSelect } from '../inputs';

type ModeratorInputStepSettingsProps = {
    stepId: string;
};

export function ModeratorInputStepSettings({ stepId }: ModeratorInputStepSettingsProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as ModeratorInputStep;

    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel>Target Var</FormLabel>
                <VarSelect
                    value={step.targetVarId}
                    onChange={(value) => updateStep(stepId, 'targetVarId', value)}
                    filterByType={['STRING']}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Options</FormLabel>
                <Stack>
                    {step.valueOptions.map((option, index) => {
                        return (
                            <Flex key={index}>
                                <Button
                                    backgroundColor="white"
                                    _hover={{ color: '#f0706e' }}
                                    _focus={{ backgroundColor: 'white' }}
                                    _active={{ backgroundColor: 'white' }}
                                    color={'grey'}
                                    leftIcon={<DeleteIcon />}
                                    onClick={() => {
                                        const valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                        valueOptions.splice(index, 1);
                                        updateStep(stepId, 'valueOptions', valueOptions);
                                    }}
                                ></Button>
                                <DrawerInput
                                    placeholder="value"
                                    value={option.targetValue}
                                    onChange={(e) => {
                                        const valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                        valueOptions[index].targetValue = e.target.value;
                                        updateStep(stepId, 'valueOptions', valueOptions);
                                    }}
                                />
                                <Spacer minW={1} />
                                <DrawerInput
                                    placeholder="Button label"
                                    value={option.btnLabel}
                                    onChange={(e) => {
                                        const valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                        valueOptions[index].btnLabel = e.target.value;
                                        updateStep(stepId, 'valueOptions', valueOptions);
                                    }}
                                />
                            </Flex>
                        );
                    })}

                    <Button
                        size={'sm'}
                        backgroundColor="white"
                        _hover={{ backgroundColor: 'white', color: 'black' }}
                        _focus={{ backgroundColor: 'white' }}
                        _active={{ backgroundColor: 'white' }}
                        color={'grey'}
                        leftIcon={<AddIcon />}
                        onClick={() => {
                            const valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                            valueOptions.push({
                                label: '',
                                key: '',
                            });
                            updateStep(stepId, 'valueOptions', valueOptions);
                        }}
                    >
                        Add Element
                    </Button>
                </Stack>
            </FormControl>
        </Box>
    );
}
